export default __webpack_public_path__ + "static/smellsLikeMango-955fb87954165e2dcb7f2630db896721.png";